import { fontWeightEnum, Text, textVariantsEnum } from '@/components/Text';

export const columnsConfig = ({ companyManagers }) => {
  return [
    {
      id: 'id',
      name: 'ID',
      sortable: false,
      cellRenderer: (row, rowIndex) => {
        return (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
          >
            {rowIndex + 1}
          </Text>
        );
      },
    },
    {
      id: 'comment',
      name: 'Comment',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
          >
            {row?.comment}
          </Text>
        );
      },
    },
    {
      id: 'type',
      name: 'Type',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
          >
            {row?.type}
          </Text>
        );
      },
    },
    {
      id: 'leaveDate',
      name: 'Leave Date',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
          >
            {row?.leaveDate}
          </Text>
        );
      },
    },
    {
      id: 'reportDate',
      name: 'Report Date',
      sortable: false,
      cellRenderer: (row) => {
        const dateObject = row.requestDate.toDate();
        let day = dateObject.getDate();
        let month = dateObject.getMonth() + 1;
        let year = dateObject.getFullYear();

        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;

        const dateString = day + '-' + month + '-' + year;
        return (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
          >
            {dateString}
          </Text>
        );
      },
    },
    {
      id: 'manager',
      name: 'Manager',
      sortable: false,
      cellRenderer: (row) => {
        const manager = companyManagers.find(
          (a) => a.userUID === row?.assignee
        );

        return (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
          >
            {manager?.userName || ''}
          </Text>
        );
      },
    },
    {
      id: 'departmentId',
      name: 'Department ID',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
          >
            {row?.teamId}
          </Text>
        );
      },
    },
    {
      id: 'status',
      name: 'Status',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Medium}
          >
            {row?.status}
          </Text>
        );
      },
    },
  ];
};
